module.exports = __webpack_public_path__ + "img/3_172.47014ef5.png";